import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { User } from '@klickdata/core/user';
import { TakeResActionValue } from '@klickdata/player/src/next-step.service';

@Component({
    selector: 'app-menu-side-event-join',
    templateUrl: './menu-side-event-join.component.html',
    styleUrls: ['./menu-side-event-join.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideEventJoinComponent implements OnInit {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    public eventOccasionId = new FormControl();
    public requestValue = new FormControl();
    public showGroupWork = false;
    public showGroups = false;
    public participantUsers: User[] = [];
    public action: 'done' | 'continueLater' | 'cancel';
    TakeResActionValue = TakeResActionValue;
    public timeSpendControl: FormControl = new FormControl();
    constructor(protected cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        if (this.navData.data.resource.occasion_dates == 1) {
            this.eventOccasionId.patchValue(this.navData.data.resource.occasion_dates[0].id);
        }
    }
    get groupJoinEvent(): boolean {
        return this.navData.data.groupJoinEvent;
    }
    onJoin() {
        if (!this.groupJoinEvent) {
            this.onDone();
        } else {
            this.showGroupWork = true;
            this.action = 'done';
            this.cdr.markForCheck();
        }
    }
    onDone() {
        this.onClose.emit({
            data: {
                type: this.navData.data.type,
                response: 1,
                requestValue: this.requestValue.value,
                eventOccasionId: this.eventOccasionId.value,
            },
        });
    }
    submit() {
        if (this.participantUsers.length == 0) return;
        this.onClose.emit({
            data: {
                action: TakeResActionValue.GROUP_WORK_DONE,
                type: this.navData.data.type,
                response: 1,
                requestValue: this.requestValue.value,
                eventOccasionId: this.eventOccasionId.value,
                userIds: this.participantUsers.map((user) => user.id),
                timeSpend:
                    this.timeSpendControl.value && this.action == 'done' ? this.timeSpendControl.value : undefined,
            },
        });
    }
}
